import { render, staticRenderFns } from "./EditarQtdePacote.vue?vue&type=template&id=6744b99b&"
import script from "./EditarQtdePacote.vue?vue&type=script&lang=js&"
export * from "./EditarQtdePacote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports